import './styles.scss';
import React from 'react';

interface Props {
    size?: 'default' | 'large';
}

// The "I" is DM Serif Display's glyph (OFL) as a path, so no extra font loads.
// Same drawing as cvat-ui/dist/favicon.ico.
const GLYPH = 'M12.88 24V23.76L13.37 23.56Q13.85 23.39 14.01 23.1Q14.17 22.81 14.17 22.33V9.67Q14.17 9.19 14.02 8.9Q13.88 8.61 13.37 8.44L12.88 8.24V8H19.12V8.24L18.63 8.44Q18.15 8.61 17.99 8.9Q17.83 9.19 17.83 9.67V22.33Q17.83 22.81 17.99 23.09Q18.15 23.37 18.63 23.56L19.12 23.76V24Z';

export default function BrandLogo({ size = 'default' }: Props): JSX.Element {
    return (
        <span className={`cvat-brand-logo cvat-brand-logo-${size}`}>
            <svg className='cvat-brand-logo-mark' viewBox='0 0 32 32' aria-hidden>
                <rect width='32' height='32' rx='7' />
                <path d={GLYPH} />
            </svg>
            Interiorrr
        </span>
    );
}
